import React, { Fragment } from 'react'
import PropTypes from 'prop-types'

function TabButtonFilled({ label, onClick, wide }) {
  return (
    <Fragment key={`tab-button-filled-${label}`}>
      {wide && (
        <svg
          height="35px"
          version="1.1"
          viewBox="0 0 226 35"
          width="226px"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
            <path
              d="M38.2689118,0.999999998 L187.991089,1.00983112 C194.248778,1.06559322 199.273507,2.55186945 203.040681,5.52832868 C206.797216,8.49638106 209.28119,12.9340034 210.544201,18.8048821 C211.925272,25.2245376 215.050983,30.0250112 219.885643,33.2319731 C221.570093,34.3493146 223.46656,35.2729235 225.576053,36 L197.999942,36 L27.0002468,36.0098708 L0.683123036,36.0033766 C2.79654359,35.2757837 4.69627604,34.3510449 6.38333447,33.2319731 C11.2179943,30.0250112 14.3437057,25.2245376 15.7247764,18.8048821 C16.8957686,13.3617381 19.1155038,9.15093664 22.4270671,6.1997592 C25.7336688,3.25300347 30.1159603,1.57571211 35.5529789,1.12339463 C36.0719642,1.04554247 36.5318111,1.00987082 37.0009516,1.00987036 L37.7222669,1.00918393 C37.9066313,1.00483334 38.0922943,1.00175585 38.2689118,0.999999998 Z"
              fill="currentColor"
              id="tab-button-filled-wide"
              stroke="currentColor"
              strokeWidth="2"
            />
            <text
              dominantBaseline="middle"
              onClick={onClick}
              textAnchor="middle"
              x="50%"
              y="53%"
            >
              {label}
            </text>
          </g>
        </svg>
      )}
      {!wide && (
        <svg
          aria-label={label}
          height="41"
          role="tab"
          viewBox="0 0 159 41"
          width="159"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
            <path
              d="M107 2c.187.002.374.005.559.01H108c.404 0 .803.024 1.195.07 11.73.778 18.839 6.949 21.327 18.515C133.162 32.865 142.41 39 158.269 39H118l-75 .01V39H1c15.858 0 25.107-6.135 27.747-18.405C31.387 8.325 39.227 2.126 52.27 2l-.001.036c.242-.017.486-.026.732-.026l54-.001z"
              fill="currentColor"
              onClick={onClick}
            />
          </g>
          <text
            dominantBaseline="middle"
            onClick={onClick}
            textAnchor="middle"
            x="50%"
            y="53%"
          >
            {label}
          </text>
        </svg>
      )}
    </Fragment>
  )
}

TabButtonFilled.propTypes = {
  label: PropTypes.string,
  onClick: PropTypes.func,
  wide: PropTypes.bool,
}

export default TabButtonFilled
